import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
})
export class LoadingComponent implements OnInit {

  @Input() inline = false;
  @Input() text = 'Chargement en cours';
  @Input() textAlignment = 'center';
  @Input() showText = true;
  @Input() loading = true;
  @Input() spinnerHeight = 20;
  @Input() sticky = false;
  constructor() { }

  ngOnInit() {}

}
